<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`发票抬头详情`"
    width="900px"
    height="600px"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form disabled v-loading="editLoading" :model="editForm" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="抬头类型" prop="type">
            <el-radio-group v-model="editForm.type">
              <el-radio-button :label="0">个人</el-radio-button>
              <el-radio-button :label="1">公司</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="抬头名称" prop="ivName">
            <el-input v-model.trim="editForm.ivName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位税号" prop="ivNo">
            <el-input v-model.trim="editForm.ivNo" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册地址" prop="ivAddress">
            <el-input v-model.trim="editForm.ivAddress" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="注册电话" prop="ivPhone">
            <el-input v-model.trim="editForm.ivPhone" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开户银行" prop="ivBank">
            <el-input v-model.trim="editForm.ivBank" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="银行账号" prop="ivAccount">
            <el-input v-model.trim="editForm.ivAccount" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import { getInvoiceTitle } from '@/api/invoice';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      editLoading: false,
      editForm: {}
    };
  },
  computed: {},
  watch: {
    visible(val) {
      if (val && this.activeId) {
        this.getDetailData();
      }
    }
  },
  methods: {
    async getDetailData() {
      this.editLoading = true;
      try {
        const { data } = await getInvoiceTitle({ id: this.activeId });
        this.editForm = {
          type: data.type,
          devName: data.devName,
          ivNo: data.ivNo,
          ivAddress: data.ivAddress,
          ivPhone: data.ivPhone,
          ivBank: data.ivBank,
          ivAccount: data.ivAccount
        };
      } finally {
        this.editLoading = false;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>

<style scoped></style>
